import DateFnsUtils from "@date-io/date-fns";
import { Grid, Paper, TextField } from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { Select } from "antd";
import { Formik } from "formik";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getData } from "../../../api/apiCaller";

const LIST_TICKET_STATUS = [
  { name: "Mới tạo", typeId: [0, 1] },
  { name: "Đang xử lý", typeId: [0, 1, 2] },
  { name: "Đã xử lý", typeId: [0, 1] },
  { name: "Mở lại", typeId: [2] },
  { name: "Đã có kết quả", typeId: [2] },
  { name: "Đã hoàn thành", typeId: [2] },
];

// TODO chưa search được theo trạng thái, mã điện thoại viên
const SearchBar = ({ onSubmit, onExport }) => {
  let listTicketTypes = useSelector((state) => state.ticket.ticketType);
  const [listCities, setListCities] = useState([]);
  const [subOrgs, setSubOrgs] = useState([]);
  const [districts, setDistrict] = useState([]);
  const [ticketStatus, setTicketStatus] = useState([]);

  listTicketTypes = listTicketTypes.filter((item) =>
    [
      "628b39e96d052a3eed1b2fd6",
      "628b3a0d6d052a3eed1b2fd7",
      "629591935ed4e20c2c439604",
    ].includes(item.id)
  );
  listTicketTypes.map((item, index) => (item.code = index));

  useEffect(() => {
    callApiGetCities();
  }, []);

  const callApiGetCities = async (name = null, limit) => {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/city-post-office", {
      filter: { where, limit },
    });
    setListCities(data);
  };

  const getProvice = async (citycode, districtcode) => {
    const where = {
      ...(citycode && !districtcode && { citycode }),
      ...(districtcode && { districtcode }),
    };
    const { data } = await getData("/vnpost/province", {
      filter: { where },
    });
    setSubOrgs(data);
  };

  const getDistrict = async (citycode) => {
    const where = {
      ...(citycode && { citycode }),
    };
    const { data } = await getData("/vnpost/district-post-office", {
      filter: { where },
    });
    setDistrict(data);
  };

  const loadPostOffice = (cityCode, districtCode) => {
    if (cityCode) {
      getDistrict(cityCode);
    }
    getProvice(cityCode, districtCode);
  };

  const filterTicket = (typeId) => {
    setTicketStatus([]);
    const type = listTicketTypes.find((item) => item.id == typeId);
    if (!type) {
      return;
    }
    const status = LIST_TICKET_STATUS.filter((item) =>
      item.typeId.includes(type.code)
    );
    setTicketStatus([...status]);
  };

  return (
    <Formik
      initialValues={{
        source: "",
        ticketType: null,
        // refId: "",
        // packageCode: "",
        agent: null,
        // status: null,
        handler: null,
        from: new Date().setHours(0, 0, 0, 0),
        to: new Date().setHours(23, 59, 59, 999),
        phoneNumber: "",
        cityCode: null,
        districtCode: null,
        subOrg: null,
      }}
      onSubmit={onSubmit}>
      {({
        values,
        handleSubmit,
        isSubmitting,
        getFieldProps,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="flexGridCareReport">
          <Paper style={{ padding: 20 }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container spacing={24}>
                <Grid item xs={6} sm={4} md={3}>
                  <InlineDatePicker
                    label="Từ ngày"
                    variant="outlined"
                    maxDate={new Date()}
                    format="dd-MM-yyyy"
                    value={values.from}
                    InputLabelProps={{ shrink: true }}
                    onChange={(newValue) => setFieldValue("from", newValue)}
                    clearable={true}
                    keyboard
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <InlineDatePicker
                    label="Đến ngày"
                    variant="outlined"
                    maxDate={new Date()}
                    minDate={values.from}
                    format="dd-MM-yyyy"
                    InputLabelProps={{ shrink: true }}
                    value={values.to}
                    onChange={(newValue) => setFieldValue("to", newValue)}
                    clearable={true}
                    keyboard
                    fullWidth
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <div className="autocomplete-list-phone-number__container">
                    <label className="autocomplete-list-phone-number__label">
                      Loại yêu cầu
                    </label>
                    <Select
                      showSearch
                      placeholder="Tất cả"
                      optionFilterProp="children"
                      value={values.ticketType}
                      className="autocomplete-list-phone-number__select"
                      popupClassName="autocomplete-list-phone-number__dropdown"
                      onChange={(newValue) => {
                        setFieldValue("ticketType", newValue);
                        filterTicket(newValue);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        { value: null, label: "Tất cả" },
                        ...(listTicketTypes || []).map((d) => ({
                          value: d.id,
                          label: d.name,
                        })),
                      ]}
                    />
                  </div>
                </Grid>

                {/* <Grid item xs={6} sm={4} md={3}>
                    <div className="autocomplete-list-phone-number__container">
                      <label className="autocomplete-list-phone-number__label">
                        Trạng thái ticket
                      </label>
                      <Select
                        showSearch
                        placeholder="Tất cả"
                        optionFilterProp="children"
                        value={values.status}
                        className="autocomplete-list-phone-number__select"
                        popupClassName="autocomplete-list-phone-number__dropdown"
                        onChange={(newValue) =>
                          setFieldValue("status", newValue)
                        }
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          { value: null, label: "Tất cả" },
                          ...(ticketStatus || []).map((d) => ({
                            value: d.name,
                            label: d.name,
                          })),
                        ]}
                      />
                    </div>
                  </Grid> */}

                <Grid item xs={6} sm={4} md={3}>
                  <TextField
                    label="Số điện thoại"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    fullWidth
                    {...getFieldProps("phoneNumber")}
                  />
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <div className="autocomplete-list-phone-number__container">
                    <label className="autocomplete-list-phone-number__label">
                      Bưu điện tỉnh/thành phố
                    </label>
                    <Select
                      showSearch
                      placeholder="Tất cả"
                      optionFilterProp="children"
                      value={values.cityCode}
                      className="autocomplete-list-phone-number__select"
                      popupClassName="autocomplete-list-phone-number__dropdown"
                      onChange={(newValue) => {
                        setFieldValue("cityCode", newValue);
                        setFieldValue("districtCode", null);
                        setFieldValue("subOrg", null);
                        loadPostOffice(newValue, null);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        { value: null, label: "Tất cả" },
                        ...(listCities || []).map((d) => ({
                          value: d.code,
                          label: `${d.code} - ${d.name}`,
                        })),
                      ]}
                    />
                  </div>
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <div className="autocomplete-list-phone-number__container">
                    <label className="autocomplete-list-phone-number__label">
                      Bưu điện huyện
                    </label>
                    <Select
                      showSearch
                      placeholder="DD-MM-YYYY"
                      optionFilterProp="children"
                      value={values.districtCode}
                      plan
                      className="autocomplete-list-phone-number__select"
                      popupClassName="autocomplete-list-phone-number__dropdown"
                      onChange={(newValue) => {
                        setFieldValue("districtCode", newValue);
                        setFieldValue("subOrg", null);
                        loadPostOffice(null, newValue);
                      }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        { value: null, label: "Tất cả" },
                        ...(districts || []).map((d) => ({
                          value: d.code,
                          label: d.name,
                        })),
                      ]}
                    />
                  </div>
                </Grid>

                <Grid item xs={6} sm={4} md={3}>
                  <div className="autocomplete-list-phone-number__container">
                    <label className="autocomplete-list-phone-number__label">
                      Bưu cục
                    </label>
                    <Select
                      showSearch
                      placeholder="DD-MM-YYYY"
                      optionFilterProp="children"
                      value={values.subOrg}
                      className="autocomplete-list-phone-number__select"
                      popupClassName="autocomplete-list-phone-number__dropdown"
                      onChange={(newValue) => setFieldValue("subOrg", newValue)}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        { value: null, label: "Tất cả" },
                        ...(subOrgs || []).map((d) => ({
                          value: d.code,
                          label: d.fullname,
                        })),
                      ]}
                    />
                  </div>
                </Grid>

                {/* <Grid item xs={6} sm={4} md={3}>
                    <TextField
                      label="Mã bưu gửi"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      {...getFieldProps("packageCode")}
                    />
                  </Grid> */}

                {/* <Grid item xs={6} sm={4} md={3}>
                    <TextField
                      label="Mã ticket"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      {...getFieldProps("refId")}
                    />
                  </Grid> */}
                <Grid
                  item
                  xs={6}
                  sm={4}
                  md={3}
                  direction="row"
                  style={{ display: "flex", gap: "12px" }}>
                  <Tooltip title="Tìm kiếm" disableFocusListener>
                    <Fab color="primary" aria-label="Search" type="submit">
                      <Search />
                    </Fab>
                  </Tooltip>

                  {/* <Tooltip title="Tải báo cáo" disableFocusListener>
                    <Fab
                      color="primary"
                      aria-label="Search"
                      onClick={() => onExport(values)}>
                      <Icon>save_alt</Icon>
                    </Fab>
                  </Tooltip> */}
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </Paper>
        </form>
      )}
    </Formik>
  );
};

export default SearchBar;
